import React, { useEffect, useState } from 'react';
import { ActivityItem, Stack, Link, Icon } from '@fluentui/react';
import moment from 'moment';
import styles from './ChatsHistory.module.scss';
import IConversationResponse from '../../models/IConversationResponse';
import { ChatMode } from '../../enums/ChatMode';
import IBotService from '../../interfaces/IBotService';
import { BotServiceFactory } from '../../services/BotServiceFactory';
import Constants from '../../constants/Constansts';

interface ChatsHistoryProps {
  chat_mode: ChatMode;
  onClick: (conversation_id: string) => void;
  handleError: (error: any) => void;
  conversationId:string
}

const ChatsHistory: React.FC<ChatsHistoryProps> = ({ chat_mode, onClick, handleError ,conversationId}) => {
  const [conversations, setConversations] = useState<IConversationResponse[]>([]);
  const [activityItems, setActivityItems] = useState<any[]>([]);
  const [clickedLink, setClickedLink] = useState<string | null>(null);

  const handleLinkClick = (conversation_id: string) => {
    setClickedLink(conversation_id);
  };

  const generateActivityItems = (
    conversations: IConversationResponse[],
    clickedLink: string | null
  ) => {
    return conversations.map(({ conversation_id, title, created }) => ({
      key: conversation_id,
      activityDescription: [
        <Link
          key={1}
          onClick={() => {
            onClick(conversation_id);
            handleLinkClick(conversation_id);
          }}
          className={styles.linkClicked}
        >
          {title}
        </Link>,
      ],
      activityIcon: (
        <Icon
          iconName={clickedLink === conversation_id ? 'WorkItemBarSolid' : 'OfficeChatSolid'}
          className={styles.iconClicked}
        />
      ),
      timeStamp: <span className={styles.timeStamp}>{moment.utc(created).local().fromNow()}</span>,
    }));
  };

  const fetchConversations = async () => {
    try {
      const botService: IBotService = BotServiceFactory.getBotService(Constants.USE_MOCK_SERVICE);
      const retrievedConversations = await botService.getConversations(
        chat_mode,
        Constants.OFFSET,
        Constants.HISTORY_LIMIT
      );
      setConversations(retrievedConversations);

      console.log('retrievedConversations', retrievedConversations);
    } catch (error: any) {
      console.error('Failed to fetch conversations:', error);
      handleError(error);
    }
  };

  useEffect(() => {
    fetchConversations();
  }, [chat_mode,conversationId]);

  useEffect(() => {
    const items = generateActivityItems(conversations, clickedLink);
    setActivityItems(items);
  }, [conversations, chat_mode, clickedLink]);

  return (
    <Stack
      tokens={{ childrenGap: 10 }}
      className={styles.activityItem}
      styles={{ root: { maxHeight: 'calc(100vh - 70px - 45px)', overflowY: 'auto' } }}
    >
      {activityItems.map(item => (
        <ActivityItem {...item} key={item.key} />
      ))}
    </Stack>
  );
};

export default React.memo(ChatsHistory);
